export const PATH_HYDRATION = '/hydration';
